<neo-form-field [subscriptSizing]="subscriptSizing()">
  @if (label()) {
    <neo-label>{{ label() }}</neo-label>
  }
  
  <textarea
    neoInput
    class="textarea-field"
    [class.textarea-field--no-resize]="!resizable()"
    [required]="required()"
    [errorStateMatcher]="errorStateMatcher"
    [ngModel]="value"
    (ngModelChange)="onTextareaChange($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder()"
    [disabled]="disabled"
    [rows]="rows()"
    [attr.aut-id]="autId()"
    [attr.aria-label]="ariaLabel() || null"
    [attr.maxlength]="maxlength()"
  ></textarea>
  @if (hint()) {
    <neo-hint>{{ hint() }}</neo-hint>
  }

  <!-- Error messages via reusable component -->
  <cm-field-errors
    [control]="ngControl()?.control || null"
    [label]="label()"
    [customMessages]="errorMessages()"
    [showErrorsWhen]="showErrorsWhen()"
    [hideErrors]="hideErrors()"
    [constraints]="{
      maxlength: maxlength(),
      minlength: minlength(),
      min: null,
      max: null
    }"
  />

  <!-- Legacy ng-content projection for backward compatibility -->
  <ng-content />
</neo-form-field>
